
import React, {Component} from 'react';
import Autocomplete from 'react-autocomplete';
import "./ck-autocomplete.css"
import $ from 'jquery';

class CKAutocomplete extends Component {

  constructor(...args){
    super(...args)
    this.state = {}
  }

  onKeyPress(e){
    // console.log('key press from ck auto',e.target.value)
  }

  onFocus() {
    this.input.focus()
  }

  render(){
    let {disabled,onKeyPress,choiceStyle,textAlign,inTable,isNumberFormat,onFocus,workNo} = this.props
    onKeyPress = (onKeyPress!==undefined)?onKeyPress:this.onKeyPress.bind(this)
    onFocus = (onFocus!==undefined)?onFocus:this.onFocus.bind(this)
    return (
      <Autocomplete
        ref={el => this.input = el}
        wrapperStyle={{display:'inline'}}
        renderInput={(props)=>{
          return <input {...props}
          className={'form-auto form-control ' + textAlign} 
          placeholder={this.props.placeholder}
          style={{height: this.props.height, width: this.props.width}} 
          onKeyPress={onKeyPress}
          onFocus={onFocus}
          disabled={disabled}/>
        }}        
        shouldItemRender={this.props.shouldItemRender}
        getItemValue={item => (isNumberFormat?item.label.replace(/\B(?=(\d{3})+(?!\d))/g, ','):item.label)}
        renderItem={(item, highlighted) =>
          <div
            style={{ background: workNo===item.work_no ? '#eee' : '#fff' }}
            key={item.id}
            className="ck-input-auto-list"
          >
            {isNumberFormat?item.label.replace(/\B(?=(\d{3})+(?!\d))/g, ','):item.label}
          </div>
        }
        renderMenu={(items, value, style)=>{
          if (items.length==0) {
            if (inTable)
              $('.table-responsive').css( "overflow-x", "auto" );
            
            return <div></div>
          } else if (items.length<=10) {
            if (inTable)
              $('.table-responsive').css( "overflow-x", "initial" );
            
            return <div style={{top:this.props.top}} className="ck-autocomplete-box"><div className="ck-input-auto" style={choiceStyle} children={items} /></div>
          }
          if (inTable)
            $('.table-responsive').css( "overflow-x", "initial" );
          
          return <div style={{top:this.props.top}} className="ck-autocomplete-box"><div className="ck-input-auto fixed-height" style={choiceStyle} children={items} /></div>
        }}        
        {...this.props}
      />
    )
  }
}

CKAutocomplete.defaultProps = {
  top: '',
  height: '',
  width: '',
  choiceStyle: {},
  placeholder: '',
  disabled:false,
  onKeyPress:undefined,
  onFocus:undefined,
  textAlign:'',
  shouldItemRender:(item, value) => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1,
  inTable:false,
  isNumberFormat:false,
  workNo:''
}

export default CKAutocomplete;





// WEBPACK FOOTER //
// ./src/component/element/CKAutocomplete.js